import { useAtom } from "jotai";
import { Query } from "@repo/rq-api-public";
import Checkbox from "../ui/Checkbox";
import { cn } from "../../styles/utils";
import { textStyles } from "../../styles/typography";
import {
  cateringEmailOptInAtom,
  boatingClubEmailOptInAtom,
} from "./store";

// Two opt-in checkboxes shown below the promo code field on the contact info
// step. Gated per platform account by BoatingAndCateringOptInsEnabled. State is
// kept in atoms so CustomerDetailsForm can read it on submit even though the
// checkboxes render outside its <form> element.
export default function BoatingAndCateringOptIns() {
  const { data: platformAccountSettings } =
    Query.usePlatformAccountSettingsGETQuery();
  const show =
    platformAccountSettings?.settings?.boatingAndCateringOptInsEnabled ?? false;

  const [cateringEmailOptIn, setCateringEmailOptIn] = useAtom(
    cateringEmailOptInAtom,
  );
  const [boatingClubEmailOptIn, setBoatingClubEmailOptIn] = useAtom(
    boatingClubEmailOptInAtom,
  );

  if (!show) return null;

  return (
    <div
      className={cn(
        textStyles.body1,
        "widget-contact-form__opt-ins flex flex-col gap-3 text-blue-dark",
      )}
    >
      <Checkbox
        id="cateringEmailOptIn"
        name="cateringEmailOptIn"
        label="Email me catering options"
        checked={cateringEmailOptIn}
        onChange={setCateringEmailOptIn}
      />
      <Checkbox
        id="boatingClubEmailOptIn"
        name="boatingClubEmailOptIn"
        label="I'm interested in joining the seasonal Boat Club"
        checked={boatingClubEmailOptIn}
        onChange={setBoatingClubEmailOptIn}
      />
    </div>
  );
}
